export enum ProductCardStyleType {
    Style_1,
    Style_2,
    Style_3,
    Style_4,
}